import React from 'react'
import PropTypes from 'prop-types'
import RadioButton from '../../ui/RadioButton'
import TextInput from '../../ui/TextInput'

const TextVariableInput = ({ value, clearValue, variableId, onChange, onClear, onCancelClear }) => {
  const radioName = `text-action-${variableId}`

  return (
    <div>
      <RadioButton
        checked={clearValue}
        id={`${radioName}-clear`}
        label="Supprimer les valeurs"
        name={radioName}
        value="clear"
        onChange={onClear}
      />
      <RadioButton
        checked={!clearValue}
        className="mt-2"
        id={`${radioName}-replace`}
        label="Remplacer les valeurs par"
        name={radioName}
        value="replace"
        onChange={onCancelClear}
      />
      {clearValue ? null : (
        <TextInput
          className="mt-2"
          placeholder="Nouvelle valeur"
          value={value}
          onChange={onChange}
        />
      )}
    </div>
  )
}

TextVariableInput.propTypes = {
  clearValue: PropTypes.bool,
  onCancelClear: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  variableId: PropTypes.number.isRequired
}

TextVariableInput.defaultProps = {
  clearValue: false
}

export default TextVariableInput
